import { gql } from '@apollo/client';

export default class UserNotificationSubscription {
    static USER_NOTIFICATION_COUNT_UPDATED = gql`
        subscription userNotificationCountUpdated($type: String!) {
            userNotificationCountUpdated(type: $type)
        }
    `;
}
